module.exports = __webpack_public_path__ + "static/media/wiz_kayak_selected_ic.52122c7a.svg";